<script>
import dayjs from 'dayjs';
import { mapActions, mapState } from 'vuex';
import createDebounce from '@/utils/debounce';
import { CloseOutlined } from '@ant-design/icons-vue';
import itemDiscount from '@/pages/promotions/promoCodes/createOrEditPromoCode/Item-discount.vue';
import TERMS from '@/pages/promotions/promoCodes/createOrEditPromoCode/constants';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const {
  TARGET_TYPE_OPTIONS,
  VALUE_TYPE_OPTIONS,
  USERS_TYPE_OPTIONS,
  LIMIT_OPTIONS,
} = TERMS;

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  components: { CloseOutlined, itemDiscount },
  data() {
    return {
      title: 'Create new',
      formatDate: 'YYYY-MM-DD',
      optionsAvailable: TARGET_TYPE_OPTIONS,
      optionsValueCart: VALUE_TYPE_OPTIONS,
      optionsUserType: USERS_TYPE_OPTIONS,
      optionsLimitUsage: LIMIT_OPTIONS,
      // value: '',
      searchText: '',
      targetTypeNewProduct: '',
      mainProduct: {},
      searchedUsers: [],
      activeIntervals: [{
        startDate: undefined,
        endDate: undefined,
      }],
      products: [],
      visibleCustomProduct: [],
      collections: [],
      optionsForProduct: [],
      oldSelectedCategories: [],
      selectedCategories: [],
      availableOnUsers: [],
      visibleNotification: false,
      firstStep: true,
      selectedProductValues: undefined,
      selectedMainProduct: undefined,
      selectedOptionsForMainProduct: undefined,
      selectedCollectionForCustomProduct: undefined,
      selectedCustomProducts: undefined,
      promoCodeDetails: {
        autoApplyToCart: false,
        isOrderIncludeAllProducts: true,
        isGiftCard: false,
        isActive: true,
        name: '',
        targetType: '',
        valueType: 'fixed',
        userLimitType: 'specific',
        limitPerUserType: 'limited',
        codeLimitType: 'limited',
        value: 0,
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    offset: {
      type: Number,
      required: true,
    },
    promoCodeId: {
      type: Number,
    },
    categoriesList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    dayjs,
    createDebounce,
    ...mapActions({
      getOnePromoCodeAction: 'promotions/getOnePromoCode',
      searchUserForPromoCodeAction: 'users/searchUserForPromoCode',
      getProductListForPromoAction: 'products/getProductListForPromo',
      getTemplateCollectionsAction: 'createTemplate/getTemplateCollections',
      getTemplateCollectionsFramesAction: 'createTemplate/getTemplateCollectionsFrames',
      createPromoCodeAction: 'promotions/createPromoCode',
      editPromoCodeAction: 'promotions/editPromoCode',
    }),
    hideModal() {
      this.$emit('update:show', false);
    },
    hideModalNotification() {
      this.visibleNotification = false;
    },
    changeToggle(field, value) {
      this.promoCodeDetails = {
        ...this.promoCodeDetails,
        [field]: value,
      };
    },
    handleOk() {
      const payload = {
        promoCode: {
          promoCodeDetails: {
            ...this.promoCodeDetails,
            entitledProductIds: this.promoCodeDetails.targetType === 'cart' ? [] : this.promoCodeDetails.entitledProductIds,
          },
          selectedCategories: this.selectedCategories,
        },
        params: {
          limit: this.pageSize,
          offset: this.offset,
        },
      };
      const intervals = this.activeIntervals.map((item) => ({
        startDate: dayjs.utc(dayjs(item.startDate)),
        endDate: dayjs.utc(dayjs(item.endDate)),
      }));
      if (!this.promoCodeId) {
        payload.promoCode.promoCodeDetails.activeIntervals = intervals;
        this.createPromoCodeAction(payload);
      } else {
        const payloadWithId = {
          ...payload,
          intervals: {
            activeIntervals: intervals,
          },
          categories: this.oldSelectedCategories,
          promoCodeId: this.promoCodeId,
        };
        this.editPromoCodeAction(payloadWithId);
      }
      this.hideModal();
    },
    handleSearch(value) {
      if (value) {
        createDebounce(this.searchUserForPromoCodeAction(value), 1000);
      }
    },
    handleChange(value) {
      const user = JSON.parse(
        JSON.stringify(this.findUsers.filter((item) => item.id === value)[0]),
      );
      this.availableOnUsers = [
        ...this.availableOnUsers,
        { id: user.id, email: user.email },
      ];
      this.promoCodeDetails.entitledUserIds = [
        ...(this.promoCodeDetails.entitledUserIds && this.promoCodeDetails.entitledUserIds.length
          ? this.promoCodeDetails.entitledUserIds
          : []),
        user.id,
      ];
      this.searchText = '';
    },
    deleteSpecificUser(id) {
      this.promoCodeDetails.entitledUserIds = [
        ...this.promoCodeDetails.entitledUserIds.filter((item) => item !== id),
      ];
    },
    deleteInterval(index) {
      this.activeIntervals = [
        ...this.activeIntervals.slice(0, index),
        ...this.activeIntervals.slice(index + 1),
      ];
    },
    deleteProduct(index) {
      this.promoCodeDetails.entitledProductIds = [
        ...this.promoCodeDetails.entitledProductIds.filter((item, idx) => idx !== index),
      ];
    },
    addActiveInterval() {
      this.activeIntervals = [...this.activeIntervals, {
        startDate: undefined,
        endDate: undefined,
      }];
    },
    changeArray(arr) {
      return arr.map((item) => {
        const {
          id,
          displayName,
          parentId,
          isPersonalize,
          isMatting,
        } = item;
        return {
          id,
          title: displayName,
          parentId,
          minimum: 1,
          limit: 99999,
          isPersonalize,
          isMatting,
          customDiscount: {
            type: 'fixed',
            value: 0,
            overWrite: false,
          },
        };
      });
    },
    addNewItem(type) {
      if (type !== 'cart') {
        if (type === 'product_option') {
          const options = this.mainProduct.options
            .filter((item) => this.selectedOptionsForMainProduct.includes(item.id));
          this.selectedMainProduct.options = this.changeArray(options);
        }
        if (type === 'product_product') {
          const products = this.productList
            .filter((item) => this.selectedCustomProducts.includes(item.id));
          this.selectedMainProduct.products = [...this.changeArray(products)];
        }
        this.promoCodeDetails.entitledProductIds = [
          ...(this.promoCodeDetails.entitledProductIds
            && this.promoCodeDetails.entitledProductIds.length
            ? this.promoCodeDetails.entitledProductIds
            : []
          ),
          this.selectedMainProduct,
        ];
      }
      this.selectedProductValues = undefined;
      this.selectedMainProduct = undefined;
      this.selectedOptionsForMainProduct = undefined;
      this.selectedCollectionForCustomProduct = undefined;
      this.selectedCustomProducts = undefined;
      this.visibleCustomProduct = null;
    },
  },
  computed: {
    ...mapState({
      promoCode: (state) => state.promotions.promoCodeDetails,
      findUsers: (state) => state.users.usersForPromoCode,
      productList: (state) => state.products.productList,
      materials: (state) => state.createTemplate.materials,
      frames: (state) => state.createTemplate.frames,
    }),
  },
  mounted() {
    if (this.promoCodeId) {
      this.title = 'Edit';
      this.getOnePromoCodeAction(this.promoCodeId);
    }
    this.getProductListForPromoAction();
    this.getTemplateCollectionsAction();
  },
  watch: {
    productList(newV) {
      this.products = newV.map((item) => ({
        label: item.displayName,
        value: item.id,
      }));
    },
    materials(newV) {
      this.collections = newV.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
    promoCodeDetails: {
      handler(newV) {
        if (newV.limitPerUserType === 'unlimited') {
          delete this.promoCodeDetails.limitPerUser;
        }
        if (newV.codeLimitType === 'unlimited') {
          delete this.promoCodeDetails.codeLimit;
        }
        if (newV.userLimitType === 'any') {
          delete this.promoCodeDetails.entitledUserIds;
        }
        if (!this.promoCodeId && newV.targetType && this.firstStep) {
          this.targetTypeNewProduct = newV.targetType;
          this.firstStep = false;
        }
        const hasProducts = this.promoCodeDetails.entitledProductIds
          && this.promoCodeDetails.entitledProductIds.length > 0
          && this.promoCodeDetails.entitledProductIds[0] !== null;

        if (this.promoCodeId && newV.targetType !== this.promoCode.targetType) {
          if (hasProducts) {
            this.visibleNotification = true;
            this.promoCodeDetails.targetType = this.promoCode.targetType;
          } else {
            // Update base type when products list is empty
            this.promoCode.targetType = newV.targetType;
          }
        }
        if (!this.promoCodeId && newV.targetType !== this.targetTypeNewProduct) {
          if (hasProducts) {
            this.visibleNotification = true;
            this.promoCodeDetails.targetType = this.targetTypeNewProduct;
          } else {
            // Update base type when products list is empty
            this.targetTypeNewProduct = newV.targetType;
          }
        }
      },
      deep: true,
    },
    frames(newV) {
      this.visibleCustomProduct = newV
        .filter((item) => item.frameMaterial.name === this.selectedMainProduct.collectionTitle
          && Boolean(item.productCollectionId) === false)
        .map((item) => ({
          label: item.displayName,
          value: item.id,
        }));
    },
    startDate(newV) {
      if (newV && this.endDate) {
        this.activeIntervals = [
          ...this.activeIntervals,
          { startDate: newV, endDate: this.endDate },
        ];
      }
    },
    endDate(newV) {
      if (this.startDate && newV) {
        this.activeIntervals = [
          ...this.activeIntervals,
          { startDate: this.startDate, endDate: newV },
        ];
      }
    },
    selectedProductValues(newV) {
      if (newV) {
        this.mainProduct = JSON.parse(
          JSON.stringify(this.productList.filter((item) => item.id === newV)[0]),
        );
        this.selectedMainProduct = {
          collectionTitle: this.mainProduct.frameMaterial
            ? this.mainProduct.frameMaterial.name
            : null,
          customDiscount: { type: 'fixed', value: 0, overWrite: false },
          id: this.mainProduct.id || null,
          isMatting: false,
          isPersonalize: this.mainProduct.isPersonalize || false,
          limit: 99999,
          minimum: 1,
          parentId: this.mainProduct.parentId || null,
          title: this.mainProduct.displayName,
        };
        if (this.mainProduct && this.promoCodeDetails.targetType === 'product_option') {
          this.optionsForProduct = [...this.mainProduct.options.map((item) => ({
            label: item.displayName,
            value: item.id,
          }))];
        }
      }
    },
    selectedCollectionForCustomProduct(newV) {
      if (newV) {
        const nameCheckedCollection = this.materials.filter((item) => item.id === newV)[0].name;
        this.selectedMainProduct = {
          ...this.selectedMainProduct,
          collectionTitle: nameCheckedCollection,
        };
        this.getTemplateCollectionsFramesAction();
      }
    },
    promoCode() {
      this.promoCodeDetails = {
        ...this.promoCode,
        ...(this.promoCode.entitledProductIds && this.promoCode.entitledProductIds.length
          && {
            entitledProductIds: this.promoCode.entitledProductIds.map((item) => ({
              ...item,
              customDiscount: item.customDiscount || {
                type: 'fixed',
                value: 0,
                overWrite: false,
              },
            })),
          }
        ),
        selectedCategory: this.promoCode.categories.map((item) => item.id),
        activeIntervals: this.promoCode.activeIntervals.map((item) => ({
          startDate: dayjs(item.startDate)
            .format(this.formatDate),
          endDate: dayjs(item.endDate)
            .format(this.formatDate),
        })),
      };
      this.activeIntervals = this.promoCodeDetails.activeIntervals;
      if (this.promoCodeDetails.categories && this.promoCodeDetails.categories.length) {
        this.selectedCategories = this.promoCodeDetails.categories.map((item) => item.id);
        this.oldSelectedCategories = this.selectedCategories;
      }
      if (this.promoCodeDetails.availableOnUsers && this.promoCodeDetails.availableOnUsers.length) {
        this.availableOnUsers = this.promoCodeDetails.availableOnUsers
        && this.promoCodeDetails.availableOnUsers[0] !== null
          ? this.promoCodeDetails.availableOnUsers
          : [];
      }
      delete this.promoCodeDetails.activeIntervals;
      delete this.promoCodeDetails.id;
      delete this.promoCodeDetails.isDeleted;
      delete this.promoCodeDetails.categories;
      delete this.promoCodeDetails.selectedCategory;
      delete this.promoCodeDetails.addedAt;
      delete this.promoCodeDetails.updatedAt;
      delete this.promoCodeDetails.availableOnUsers;
      delete this.promoCodeDetails.isPackage;
      delete this.promoCodeDetails.domainId;
      if (this.promoCodeDetails.limitPerUser === null) {
        delete this.promoCodeDetails.limitPerUser;
      }
      if (this.promoCodeDetails.codeLimit === null) {
        delete this.promoCodeDetails.codeLimit;
      }
      if (this.promoCodeDetails.customDiscount === null) {
        delete this.promoCodeDetails.customDiscount;
      }
      if (this.promoCodeDetails.entitledProductIds === null) {
        delete this.promoCodeDetails.entitledProductIds;
      }
      if (this.promoCodeDetails.entitledUserIds === null) {
        delete this.promoCodeDetails.entitledUserIds;
      }
    },
    findUsers(newV) {
      this.searchedUsers = newV.map((item) => ({
        label: `${item.firstName} ${item.lastName}\n${item.email}`,
        value: item.id,
      }));
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    @cancel="hideModal"
    width="600px"
  >
    <h1 class="text-2xl font-bold mb-2">
      {{ title }} promo code.
    </h1>
    <div class="column" >
      <h4>Categories: </h4>
      <a-select
        mode="multiple"
        allowClear
        style="width: 552px"
        :options="categoriesList"
        v-model:value="selectedCategories"
        placeholder="Select categories..."
      />
    </div>
    <div class="column" >
      <h4>Name new code: </h4>
      <a-input
        placeholder="Enter name for new code"
        style="width: 552px"
        v-model:value="promoCodeDetails.name"
      />
    </div>
    <div class="row toggle" >
      <h4>Should the order contain all products from the promo code? </h4>
      <a-switch
        :checked="promoCodeDetails.isOrderIncludeAllProducts"
        @change="changeToggle(
        'isOrderIncludeAllProducts',
        !promoCodeDetails.isOrderIncludeAllProducts)"
      />
    </div>
    <div :class="promoCodeDetails.targetType === 'cart' ? 'row' : 'row mini-row'">
      <div class="column" >
        <h4 :class="promoCodeDetails.targetType === 'cart' ? 'row' : 'row mini-row'">
          Available on:
        </h4>
        <div :class="promoCodeDetails.targetType === 'cart' ? 'row' : 'row mini-row'">
          <div class="column">
            <a-select
              style="width: 250px"
              placeholder="Select type..."
              :options="optionsAvailable"
              v-model:value="promoCodeDetails.targetType"
            />
            <div
              v-if="promoCodeDetails.targetType === 'product' && selectedMainProduct
              || promoCodeDetails.targetType === 'product_option' && selectedMainProduct
                && selectedOptionsForMainProduct && selectedOptionsForMainProduct.length
              || promoCodeDetails.targetType === 'product_product' && selectedMainProduct
                && selectedCollectionForCustomProduct && selectedCustomProducts"
            >
              <a-button
                type="primary"
                html-type="button"
                @click="addNewItem(promoCodeDetails.targetType)"
              >
                + Add
              </a-button>
            </div>
          </div>
          <div v-if="promoCodeDetails.targetType === 'cart'" class="column" >
            <div class="row mini-row" >
              Value:
              <a-switch
                checked-children="%"
                un-checked-children="$"
                :checked="promoCodeDetails.valueType === 'percentage'"
                @change="changeToggle(
          'valueType',
          promoCodeDetails.valueType === 'percentage' ? 'fixed' : 'percentage')"
              />
              {{ promoCodeDetails.valueType === "percentage" ? '%' : '$' }}
              <a-input
                style="width: 100px"
                v-model:value="promoCodeDetails.value"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="promoCodeDetails.targetType === 'product'
          || promoCodeDetails.targetType === 'product_option'
          || promoCodeDetails.targetType === 'product_product'"
        class="column pl"
      >
        <h4 class="row mini-row">Select product</h4>
        <a-select
          style="width: 250px"
          :options="products"
          placeholder="Select product..."
          v-model:value="selectedProductValues"
        />
        <div
          v-if="promoCodeDetails.targetType === 'product_option' && selectedMainProduct"
          class="column"
        >
          <h4>Select options</h4>
          <a-select
            mode="multiple"
            allowClear
            style="width: 250px"
            :options="optionsForProduct"
            v-model:value="selectedOptionsForMainProduct"
            placeholder="Select options..."
          />
        </div>
        <div
          v-if="promoCodeDetails.targetType === 'product_product' && selectedMainProduct"
          class="column"
        >
          <h4>Select collection</h4>
          <a-select
            style="width: 250px"
            :options="collections"
            v-model:value="selectedCollectionForCustomProduct"
            placeholder="Select category..."
          />
          <div v-if="selectedCollectionForCustomProduct" class="column">
            <h4>Select products</h4>
            <a-select
              mode="multiple"
              allowClear
              style="width: 250px"
              :options="visibleCustomProduct"
              v-model:value="selectedCustomProducts"
              placeholder="Select custom products..."
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="promoCodeDetails.targetType !== 'cart'" >
      <div
        class="column"
        v-if="promoCodeDetails.entitledProductIds
        && promoCodeDetails.entitledProductIds.length
        && promoCodeDetails.entitledProductIds[0] !== null"
      >
        <div
          class="column gray"
          v-for="(mainProduct, index) in promoCodeDetails.entitledProductIds"
          :key="mainProduct.id"
        >
          <div v-if="promoCodeDetails.targetType === 'product_product'">
            <h2>{{ mainProduct.products.reduce((acc, item) =>
              `${acc} + ${item.title}`, mainProduct.title) }}</h2>
            <h2> (Collection: {{ mainProduct.collectionTitle }})</h2>
          </div>
          <div v-else>
            <h2>{{ mainProduct.title }}</h2>
          </div>
          <div class="wrap" >
            <item-discount v-model:item="promoCodeDetails.entitledProductIds[index]" />
            <item-discount
              v-for="(option, idx) in mainProduct.options"
              :key="option.id"
              v-model:item="mainProduct.options[idx]"
            />
            <item-discount
              v-for="(product, idx) in mainProduct.products"
              :key="product.id"
              v-model:item="mainProduct.products[idx]"
            />
          </div>
          <a-button
            class="button_products"
            html-type="button"
            @click="deleteProduct(index)"
          >
            <CloseOutlined />
          </a-button>
        </div>
      </div>
    </div>
    <div class="column">
      <h4>Limit per user: </h4>
      <div class="row">
        <a-select
          style="width: 250px"
          :options="optionsLimitUsage"
          v-model:value="promoCodeDetails.limitPerUserType"
        />
        <div v-if="promoCodeDetails.limitPerUserType === 'limited'">
          <a-input
            v-model:value="promoCodeDetails.limitPerUser"
            placeholder="Enter quantity usage"
            style="width: 250px"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="column" >
        <h4>Users: </h4>
        <a-select
          style="width: 250px"
          :options="optionsUserType"
          v-model:value="promoCodeDetails.userLimitType"
        />
      </div>
      <div class="column" v-if="promoCodeDetails.userLimitType === 'specific'">
        <h4>Search users... </h4>
        <a-select
          v-model:value="searchText"
          style="width: 250px"
          show-search
          placeholder="input search text"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :options="searchedUsers"
          @search="handleSearch"
          @change="handleChange"
        />
      </div>
    </div>
    <div
      class="column"
      v-if="availableOnUsers && availableOnUsers.length
      && promoCodeDetails.userLimitType === 'specific'"
    >
      <div class="row gray" v-for="user in availableOnUsers" :key="user.id">
        <div>
          {{ user.email }}
        </div>
        <a-button
          class="button"
          html-type="button"
          @click="deleteSpecificUser(user.id)"
        >
          <CloseOutlined />
        </a-button>
      </div>
    </div>
    <div class="column" >
      <h4>Date intervals: </h4>
      <div v-for="(interval, index) in activeIntervals" class="row" :key="interval.id">
        <a-date-picker
          v-model:value="interval.startDate"
          style="width: 250px"
          :format="formatDate"
          :value-format="formatDate"
        />
        <a-button
          v-if="activeIntervals && activeIntervals.length > 1"
          class="button"
          html-type="button"
          @click="deleteInterval(index)"
        >
          <CloseOutlined />
        </a-button>
        <a-date-picker
          v-model:value="interval.endDate"
          style="width: 250px"
          :format="formatDate"
          :value-format="formatDate"
        />
      </div>
      <div
        v-if="activeIntervals && activeIntervals.length
        && activeIntervals[activeIntervals.length - 1].startDate
        && activeIntervals[activeIntervals.length - 1].endDate"
      >
        <a-button
          type="primary"
          html-type="button"
          @click="addActiveInterval()"
        >
          Add new date interval
        </a-button>
      </div>
    </div>
    <div class="column">
      <h4>Code limit: </h4>
      <div class="row">
        <a-select
          style="width: 250px"
          :options="optionsLimitUsage"
          v-model:value="promoCodeDetails.codeLimitType"
        />
        <div v-if="promoCodeDetails.codeLimitType === 'limited'">
          <a-input
            v-model:value="promoCodeDetails.codeLimit"
            placeholder="Enter quantity usage"
            style="width: 250px"
          />
        </div>
      </div>
    </div>
    <div class="row" >
      <div class="row toggle fs" >
        <h4>Active: </h4>
        <a-switch
          :checked="promoCodeDetails.isActive"
          @change="changeToggle(
        'isActive',
        !promoCodeDetails.isActive)"
        />
      </div>
      <div class="row toggle fe" >
        <h4>Auto apply to cart: </h4>
        <a-switch
          :checked="promoCodeDetails.autoApplyToCart"
          @change="changeToggle(
        'autoApplyToCart',
        !promoCodeDetails.autoApplyToCart)"
        />
      </div>
    </div>
    <div class="row" >
      <a-button
        type="primary"
        html-type="button"
        @click="handleOk()"
      >
        Save
      </a-button>
    </div>
    <a-modal
      :open="visibleNotification"
      :footer="null"
      @cancel="hideModalNotification"
      width="400px"
    >
      Selected product type doesn't match products in list.
      Please, remove unmatching products from list to be able to select this product type.
    </a-modal>
  </a-modal>
</template>

<style scoped lang="scss">
.wrap{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.row {
  width: 552px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  align-items: baseline;
}

.mini-row {
  width: 250px;
}

.gray {
  position: relative;
  border-radius: 10px;
  background-color: #98A6B0;
  padding: 10px;
}

.button_products {
  position: absolute;
  top: 10px;
  right: 10px;
}

.column {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.pl {
  padding-left: 42px;
}

.toggle {
  align-items: center;
  * {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
.fs {
  justify-content: flex-start;
}
.fe {
  justify-content: flex-end;
}
</style>
